
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/expertise-and-valuation",
      function () {
        return require("private-next-pages/content/expertise-and-valuation.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/expertise-and-valuation"])
      });
    }
  